// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BmLwa","textarea":"styles_textarea__J72az"};